import * as date from '@/helpers/date-helper'

export default {
    install(app) {
        app.config.globalProperties.$date = date
    }
}